<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card tile class="d-flex flex-column justify-center align-center">
        <h1 class="text-h1 my-5 primary--text">404</h1>
        <h2 class="text-h2 my-5 grey--text text--darken-3">Ooops!!</h2>
        <h3 class="text-h4 mb-5 grey--text text--darken-2">
          THAT PAGE DOESN'T EXIST OR IS UNAVAILABLE.
        </h3>
        <v-btn large color="primary" class="my-5" :to="{ path: '/' }"
          >กลับหน้าหลัก
        </v-btn>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: true,
    }
  },
}
</script>
